import {
  FETCH_STATISTICS_REQUEST,
  FETCH_STATISTICS_SUCCESS,
  FETCH_STATISTICS_FAILURE,
} from "../Types";

const initialState = {
  loading: false,
  statistics: null,
  error: null,
};

const statisticGeneralReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        statistics: action.payload,
        error: null,
      };

    case FETCH_STATISTICS_FAILURE:
      return {
        ...state,
        loading: false,
        statistics: null,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default statisticGeneralReducer;
